import { render, staticRenderFns } from "./cModalSendWsp.vue?vue&type=template&id=1a55c354&scoped=true"
import script from "./cModalSendWsp.vue?vue&type=script&lang=js"
export * from "./cModalSendWsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a55c354",
  null
  
)

export default component.exports